import { isNil, isEmpty, isNaN, find, get, filter, toLower, capitalize, size,  keys, reduce } from 'lodash';
import { PaymentFrequency } from '@static/payment-frequency';
import { PremiumTerms } from '@static/premium-term';
import { Nationalities } from '@static/nationalities';
import { Races } from '@static/races';
import { MaritalStatus } from '@static/marital-status';
import { Salutations } from '@static/salutation';
import { SourceOfFunds, SourceOfWealths } from '@static/sources';
import { Business } from '@static/businesses';
import { Banks } from '@static/banks';
import { UrlAnalyticModel } from '@models/MLTC_R3/UrlAnalytic.model';
import { MAX_FILE_UPLOAD_COUNT, MAX_INPROGRESS_UPLOAD_COUNT, PLANS, PLANS_CONFIG, PLANS_NAME } from '@static/config';
import { setCurrentPolicyFlow, setLoadingState } from '@redux/slices/loadingSlice';
import axios from 'axios'
import { uploadStatus } from '@redux/slices/SHIELD_STARTER/step3Slice';
import { ContactForm } from "@models/SIO/Contact.model";
import { IError } from "@utils/useForm";
import {store} from '@redux/store'
import { ROUTE_PATH } from '@static/route-paths';
import React, { LazyExoticComponent } from 'react';
declare const window: any;

if (window.LOG === false) {
  window.console.log = () => {};
  window.console.debug = () => {};
}

enum Compared {
  Greater = 1,
  Equal = 0,
  Less = -1,
}

export enum TrackType {
  PAGE_LOAD = "track_page_load",
  FORM_COMPLETE = "track_form_complete",
  FORM_ERORR = "track_form_error",
}


//Add url paths for which revamped/new hearder or footer will be used
export function setCurentPolicyFlowInStore(urlPath: string = "", dispatch: Function): boolean{
  for(let plan in PLANS_NAME){
    let isRevampedFlow: boolean = urlPath.includes(PLANS[plan])
    if(isRevampedFlow){
      let payload = PLANS_CONFIG[plan] || PLANS_CONFIG['DEFAULT']
      dispatch(setCurrentPolicyFlow(payload))
      return true
    }
  }
  return false;
}

export class Validations {

  /**Validating MM/DD/YYYY */

  static isValidRequire(input: string | number | null | undefined, type: 'number' | 'string' | 'boolean' = 'string'): boolean {
    if (isNil(input)) {
      return false;
    }
    if (type === 'number' && isNaN(input)) {
      return false;
    }
    if (type === 'string' && isEmpty(input)) {
      return false;
    }
    return true;
  }

  static isValidDayOfBirth(input: string): boolean {
    if (!this.isValidDay(input)) {
      return false;
    }
    const today = new Date();
    const dob = new Date(input);
    if (dob > today || dob === today) {
      return false;
    }
    return true;
  }

  static RegexDate = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
  static isValidDay(input: string): boolean {
    if (isNil(input) || isEmpty(input)) {
      return false;
    }
    const [month, day, year] = String(input).split('/');

    if (typeof input === 'string' && !this.RegexDate.test(`${day}/${month}/${year}`)) {
      return false;
    }
    const refDay = new Date(input);
    if (Number(month) !== (refDay.getMonth() + 1)) {
      return false;
    }

    return true;
  }

  static RegexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static isValidEmail(input: string): boolean {
    return this.RegexEmail.test(String(input).toLowerCase());
  }

  static isValidPhoneNumber(input: string | number): boolean {
    if (isNil(input)) {
      return false;
    }
    const firstNum: string = get(String(input), '[0]', '');
    if (firstNum !== '9' && firstNum !== '8') {
      return false;
    }
    if (get(String(input), 'length', 0) !== 8) {
      return false;
    }
    return true;
  }

  static isDivisible(input: number | string, dividend: number): boolean {
    const value = Number(input);
    if (isNaN(value) || dividend === 0) {
      return false;
    }
    if (value % dividend !== 0) {
      return false;
    }
    return true;
  }

  static isInRange(input: number, min: number, max: number): number {
    if (input > max) {
      return Compared.Greater;
    }
    if (input < min) {
      return Compared.Less;
    }
    return Compared.Equal;
  }

  static RegexNumeric = /^[0-9.\b]+$/;
  static isNumeric(input: string): boolean {
    return this.RegexNumeric.test(String(input).toLowerCase());
  }

  static RegexDecimal = /^((\d+(\.\d{0,2})?)|(\.\d{0,2}))$/;
  static isDecimal(input: string): boolean {
    return this.RegexDecimal.test(String(input).toLowerCase());
  }

  static RegexAlphabets = /^[a-zA-Z ]+$/;
  static isAlphabets(input: string) {
    return this.RegexAlphabets.test(input);
  }
  static RegexAlphanumeric = /^[a-zA-Z0-9 ]+$/;
  static isAlphanumeric(input: string) {
    return this.RegexAlphanumeric.test(input);
  }
  static RegexDutyOfOccupation = /^[a-zA-Z0-9 '-]*$/;
  static isDutyOfOccupationValid(input: string) {
    return this.RegexDutyOfOccupation.test(input);
  }

  static isLeapYear(year: number): boolean {
    return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
  }

  static Regex4NRIC = /^[STFG]\d{7}[A-Z]$/
  static isValidateFullNRIC(input: string): boolean {
    return this.Regex4NRIC.test(input);
  }

  static Regex4LastNRIC = /^\d{3}[A-Z]$/
  static isValidateNRIC(input: string): boolean {
    return this.Regex4LastNRIC.test(input);
  }

  static RegexUnitNumber = /(^#([a-zA-Z0-9]{1,6})-([a-zA-Z0-9]{0,6}))$|(([0]{1}))$|^([0-9]{1,6})-([0-9]{1,6})$/
  static isValidUinit(input: string, pattern?: RegExp | undefined): boolean {
    if(pattern){
      return pattern.test(input);
    }
    return this.RegexUnitNumber.test(input);
  }

  static RegexPostalCode = /^\d([0-9]{5})/
  static isValidPostalCode(input: string): boolean {
    return this.RegexPostalCode.test(input);
  }
}
export class Helpers {


  static getTypePlan(location: any): string {
    return location.pathname.includes('sio') ? 'sio' :
      location.pathname.includes('dpi') ? 'dpi' :
        (location.pathname.includes('mltc') ? 'mltc' : location.pathname.includes('shieldstarter')?"shieldstarter":location.pathname.includes("evergreen")?"evergreen":location.pathname.includes("ccp")?"ccp":"" );
  }

  static getPlanName(type: string): string {
    switch(type){
      case 'sio': {
        return 'Singlife Simple Term';
      }
      case 'dpi': {
        return 'DIRECT - Singlife Term Life';
      }
      case 'mltc': {
        return '- Singlife CareShield';
      }
      case "shieldstarter": {
        return '- Singlife Shield Starter';
      }
      case "evergreen":{
        return '- Singlife Digital Saver'
      }
      case "ccp":{
        return '- Singlife Cancer Cover Plus II'
      }
      default:
        return '';
    }
    
  }

  static getNavLevels(nav5?:string): object {
    let hash = window.location.hash;
    hash = hash.replace('/./', '/').replace('/index.html#/', '/').replace('/#/', '/');
    console.debug({ hash });
    const [origin] = hash.split('?');
    const paths: any[] = origin.split('/').filter((o: string) => o!== 'index.html#' && o!== '#');
    if(nav5){
      paths[2] = nav5
    }
    return {
      navLevel1: 'QuoteBuy',
      navLevel2: 'directsales',
      navLevel3: get(paths, '[0]', ''),
      navLevel4: get(paths, '[1]', ''),
      navLevel5: get(paths, '[2]', ''),
    }
  }
  static getPlatform(): string {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      return 'App';
    }
    return 'web';
  }

  static adobeTrack(type: TrackType, data: object) {
    console.debug('$event', type, { digitalData: data });
    try {
      if (window._satellite) {
        window.digitalData = data;
        window._satellite.track(type);
      }
    } catch (e) {
      console.error(e);
      this.retry(() => this.adobeTrack(type, data));
    }
  }

  static retry(callback: any) {
    setTimeout(callback , 10000);
  }

  static getAge(input: Date): number {
    const dobDate = new Date(input);
    const today = new Date();
    let anb: number = today.getFullYear() - dobDate.getFullYear();
    if (dobDate.getMonth() < today.getMonth()) {
      anb = anb + 1;
    }
    if (dobDate.getMonth() === today.getMonth() && dobDate.getDate() < today.getDate()) {
      anb = anb + 1;
    }
    return anb;
  }

  static scrollToTop(): void {
    if (!window) {
      return;
    }
    window.scrollTo(0, 0);
  }

  static toCurrency(input: number | string): string {
    if (typeof input === 'string') {
      return input;
    }
    return `S${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(input)}`;
  }

  static toCurrencyND(input: number): string {
    if (typeof input === 'string') {
      return input;
    }
    return `${this.toCurrency(input).replace('.00','')}`;
  }


  static toTwoDecimal(input: any): string {
    // return input.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    if (typeof input === 'string') {
      return Number(input).toFixed(2);
    }
    return input.toFixed(2);
  }

  static getPremiumTermByCode(code: string): string {
    const refer = find(PaymentFrequency, { code });
    return get(refer, 'description', '-');
  }

  static getPolicyTermByCode(code: string): string {
    const refer = find(PremiumTerms, { code });
    return get(refer, 'description', '-');
  }

  static getPremiumAmountProperty(code: string): string {
    switch(code) {
      case 'AP':
        return 'annualPremium';
      case 'HP':
        return 'halfYearlyPremium';
      case 'QP':
        return 'quarterlyPremium';
      case 'MP':
        return 'monthlyPremium';
      default:
        return '-';
    }
  }

  static getFirstYearPremiumAmountProperty(code: string): string {
    switch(code) {
      case 'AP':
        return 'firstYrAnnualPremium';
      case 'HP':
        return 'firstYrHalfYearlyPremium';
      case 'QP':
        return 'firstYrQuarterlyPremium';
      case 'MP':
        return 'firstYrMonthlyPremium';
      default:
        return '-';
    }
  }

  static getTotalPremiumAmountProperty(code: string): string {
    switch(code) {
      case 'AP':
        return 'annualPremiumOrg';
      case 'HP':
        return 'halfYearlyPremiumOrg';
      case 'QP':
        return 'quarterlyPremiumOrg';
      case 'MP':
        return 'monthlyPremiumOrg';
      default:
        return '-';
    }
  }

  static getTotalPremiumAmountAfterDiscountProperty(code: string): string {
    switch(code) {
      case 'AP':
        return 'annualPremiumAftDis';
      case 'HP':
        return 'halfYearlyPremiumAftDis';
      case 'QP':
        return 'quarterlyPremiumAftDis';
      case 'MP':
        return 'monthlyPremiumAftDis';
      default:
        return '-';
    }
  }

  static filterSalutations(gender: string | null, template: any, maritalStatus: string | null): any {
    if (!gender) {
      return template;
    }
    const genderCode = gender[0];
    let temp = filter(template, o => (o.maritalStatus !== maritalStatus));
    return filter(temp, o => (o.gender === genderCode || o.gender === 'B'));
  }

  static getHealthQuestionType(promoCode: string): string {
    if (promoCode === 'SIO1') {
      return 'SIOA1'
    }
    if (promoCode === 'SIO3') {
      return 'SIOA3'
    }
    return 'SIOB'

  }

  static getGenderNameByCode(code: string): string {
    return code === 'F' ? 'Female' : 'Male';
  }

  static getNationalityByCode(code :string): string {
    const selected = find(Nationalities, { code });
    return get(selected, 'description', '');
  }

  static getURLSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams(window.location.search);

    const hash = window.location.hash;
    const queryIndex = hash.indexOf("?");
    const hashParams =
      queryIndex !== -1
        ? new URLSearchParams(hash.substring(queryIndex + 1))
        : new URLSearchParams();

    const mergedParams = new URLSearchParams();

    searchParams.forEach((value, key) => mergedParams.set(key, value));
    hashParams.forEach((value, key) => mergedParams.set(key, value));

    return mergedParams;
  }

  static splitName(name: string): any {
    const givname = name.split(' ').slice(0, -1).join(' ');
    const surname = name.split(' ').slice(-1).join(' ');
    return {
      fullName: name,
      givname,
      surname
    }
  }

  static getBankName(code: string): string | null {
    const selected = find(Banks, { code });
    if (code === '11') {
      return null;
    }
    return get(selected, 'description', null);
  }

  static getRaceByCode(code: string): string {
    const selected = find(Races, { code });
    return get(selected, 'description', '');
  }

  static getMaritalByCode(code: string): string {
    const selected = find(MaritalStatus, { code });
    return get(selected, 'description', '');
  }

  static getStringDate(input: Date): string {
    const day = input.toLocaleString('default', { day: '2-digit' });
    const month = input.toLocaleString('default', { month: 'short' });
    const year = input.toLocaleString('default', { year: 'numeric' });

    return `${day} ${month} ${year}`;
  }

  static getSalutationByCode(code: string): string {
    const selected = find(Salutations, { code });
    return get(selected, 'description', '');
  }

  static getSourceByCode(code: string, type: 'fund' | 'wealth'): string {
    const sources = type === 'fund' ? SourceOfFunds : SourceOfWealths;
    const selected = find(sources, { value: code });
    return get(selected, 'label', '');
  }

  static getNatureByCode(code: string): string {
    const selected = find(Business, { code });
    return get(selected, 'description', '');
  }
  
  static checkNricValid(nric: string): boolean {
    const NricRegex = /(^[S|T])+/;
    return NricRegex.test(nric);
  }

  static parseDobString(input: any): string {
    if (typeof input === 'object') {
      return `${get(input, 'year', 0)}-${get(input, 'month', 0)}-${get(input, 'day', 0)}`;
    }
    return `${input}`;
  }

  static getTypeDiscount(input: string): string {
    if (toLower(input) === 'dollar') {
      return '$';
    }
    if (toLower(input) === 'percent') {
      return '%';
    }
    return '-'
  }
  static clearCached(): void{
    sessionStorage.removeItem('persist:root');
    sessionStorage.removeItem('persist:expired');
    sessionStorage.removeItem('aviva_ga_cached');
    sessionStorage.removeItem('token');
  }

  static capitalizeName(input: string): string {
    if (isEmpty(input)) {
      return "";
    }
    const names = input.split(' ').map(name => capitalize(name));
    return names.join(" ").trim();
  }


  static setUrlAnalyticParams(): UrlAnalyticModel {
    const searchParams = new URLSearchParams(window.location.search);

    const hash = window.location.hash;
    const queryIndex = hash.indexOf("?");
    const hashParams =
      queryIndex !== -1
        ? new URLSearchParams(hash.substring(queryIndex + 1))
        : new URLSearchParams();

    const mergedParams = new URLSearchParams();

    searchParams.forEach((value, key) => mergedParams.set(key, value));
    hashParams.forEach((value, key) => mergedParams.set(key, value));

    return new UrlAnalyticModel({
      utm_source: mergedParams.get("utm_source") ?? "",
      utm_medium: mergedParams.get("utm_medium") ?? "",
      utm_campaign: mergedParams.get("utm_campaign") ?? "",
      ecid: mergedParams.get("ecid") ?? "",
      pid: mergedParams.get("pid") ?? "",
      arc: mergedParams.get("arc") ?? "",
      pm: mergedParams.get("pm") ?? "",
      qrCd: mergedParams.get("qrCd") ?? "",
      form_type: mergedParams.get("form_type") ?? "",
    });
  }
  static getUrlAnalyticParams(isCombine:boolean,paramObj:any): string{
    const paramObjArr = new URLSearchParams(paramObj);
    let keysForDel: string[] = [];
    paramObjArr.forEach((value, key)=>{
      if(value === '') {
        keysForDel.push(key);
      }
    });

    keysForDel.forEach((key) => {
      paramObjArr.delete(key);
    })
    const paramString = paramObjArr.toString();

    if (paramString) {
      if (isCombine) {
        return '&' + paramString;
      } else {
        return '?' + paramString;
      }
    } else {
      return "";
    }
  }

}

export function formatDate(date: string) {
  const d = new Date(date);
  const month = d.toLocaleString("default", {
    month: "short",
  });
  const dayNumber = d.toLocaleString('en-US', {
    day: '2-digit'})

  return `${dayNumber} ${month} ${d.getFullYear()} `;
}

export const modifyFiles = (existingFiles: any, files: any) => {
  let fileToUpload = {};
  const uploadableFileCount = MAX_FILE_UPLOAD_COUNT - size(existingFiles);
  const count = Math.min(files.length, uploadableFileCount);
  const ids:number[] = Object.keys(existingFiles).map(Number);

  if(ids.length < 1) ids.push(0)

  for (let i = 0; i < count; i++) {
    const id = Math.max(...ids) + i + 1;
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    fileToUpload = {
      ...fileToUpload,
      [id]: {
        id,
        file: files[i],
        fileName: files[i].name,
        progress: 0,
        cancelSource: source,
        status:
          i < MAX_INPROGRESS_UPLOAD_COUNT
            ? uploadStatus.QUEUE
            : uploadStatus.INACTIVE,
      },
    };
  }

  return fileToUpload;
};
// This is used in both Shieldstarter and Evergreen.
export interface NameSelectorItemProps {
  id: number;
  title: string;
  selected: boolean;
  order: number
}

// This is used in both Shieldstarter and Evergreen.
export const nameChunks = (tempName: string, type: string, name: string, setFirstNameListingChucks: Function, setLastNameListingChucks:Function) => {
  let tempObjFN: NameSelectorItemProps[] = [];
  let temp: string[] = [];
  const placeHolder = Symbol("placeholder")

  if (tempName && name) {
    const arr = tempName.split(" ");
    const nameaArr = name.split(" ");
    arr.forEach((e: any, i: number) => {
      const nameIndex = nameaArr.findIndex(
        (name: any, index: number) => name === e
      );
      if(nameIndex !== -1){
      nameaArr.splice(nameIndex,1,placeHolder.toString());}
      const isFirstName = nameIndex !== -1;
      let tempFNChucks = {
        id: i,
        title: e,
        selected: isFirstName,
        order: nameIndex,
      };
      tempObjFN.push(tempFNChucks);
      temp.push(e);
    });
  }
  if (type === "firstName") {
    setFirstNameListingChucks([...tempObjFN]);
  }

  if (type === "lastName") {
    setLastNameListingChucks([...tempObjFN]);
  }
};

// This is used in both Shieldstarter and Evergreen.
// Salution list object for dropdown
export function getSalutationList(values:string="",){
  let salutationList: any= [];
  if(!values){
    return []
  }
  if (values?.toLowerCase() === "male") {
    salutationList = [
      { id: "Mr", label: "Mr" },
      { id: "Master", label: "Master" },
      { id: "Dr", label: "Dr" },
    ];
  } else if (values?.toLowerCase() === "female") {
    salutationList = [
      { id: "Mrs", label: "Mrs" },
      { id: "Ms", label: "Ms" },
      { id: "Madam", label: "Madam" },
      { id: "Dr", label: "Dr" },
    ];
  }
  return salutationList;
}


//Used in MYInfo form validataion
// This will be shared with Evergreen(Secure saver) and future products.
export const validate = (values: ContactForm) => {
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      return { ...result, [field]: validateField(values, field) };
    },
    {}
  );
  return errors;
};

// This will be shared with Evergreen(Secure saver) and future products.
export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case "salutation":
      if (isNil(value)) {
        error = { isValid: false, message: "Please select a salutation" };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "Please select a salutation" };
        }
      }
      break;
    case "mobileNum":
      if (isNil(value)) {
        error = { isValid: false, message: "Enter a valid 8-digit Singapore mobile number." };
      } else {
        if (value.length < 8) {
          error = { 
            isValid: false,
            message: "Enter a valid 8-digit Singapore mobile number."
          }
        } else if (value.length > 8) {
          error = {
            isValid: false,
            message: "Enter a valid 8-digit Singapore mobile number."
          };
        } else if (!["8", "9"].includes(value.charAt(0))) {
          error = {
            isValid: false,
            message: "Enter a valid 8-digit Singapore mobile number.",
          };
        }
      }
      break;
    case "emailId":
      if (isNil(value)) {
        error = { isValid: false, message: "Enter in the format: example@email.com." };
      } else {
        if (isEmpty(value)) {
          error = { isValid: false, message: "Enter in the format: example@email.com."};
        } else {
          if (!Validations.isValidEmail(value)) {
            error = {
              isValid: false,
              message: "Enter in the format: example@email.com."
            };
          }
        }
      }
      break;
  }
  return error;
};

export function LoadingScreen(show=true){
  if(show){
    store.dispatch(setLoadingState(true))
  }
  else{
    store.dispatch(setLoadingState(false))
  }
}

// Get the product url to which user has to be re-routed post FAST redirection from bank
export function getFastPaymentRedirectedUrlAfterRedirect(productName: PLANS_NAME) {

  switch(productName){
   case PLANS_NAME.EVER_GREEN:
    return ROUTE_PATH.EVER_GREEN_FAST_PAYMENT
    default:
      return '/error'
  }
  

  return ""
}
//Lazy loader

interface LazyComponent<T> extends LazyExoticComponent<any> {
  preload: () => Promise<any>;
}

export const ReactLazyPreload = <T>(importStatement: () => Promise<any>): LazyComponent<T> => {
  const Component = React.lazy(importStatement);
  (Component as LazyComponent<T>).preload = importStatement;
  return Component as LazyComponent<T>;
};

